var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgFavoriteMain = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.827 25.6856C15.3737 25.8456 14.627 25.8456 14.1737 25.6856C10.307 24.3656 1.66699 18.8589 1.66699 9.5256C1.66699 5.4056 4.98699 2.07227 9.08032 2.07227C11.507 2.07227 13.6537 3.2456 15.0003 5.05893C15.6854 4.13343 16.5776 3.38123 17.6057 2.86259C18.6337 2.34395 19.7689 2.07328 20.9203 2.07227C25.0137 2.07227 28.3337 5.4056 28.3337 9.5256C28.3337 18.8589 19.6937 24.3656 15.827 25.6856Z",
    stroke: "#1E2F97",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFavoriteMain, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/favorite-main.7064eaf5.svg";
export { ForwardRef as ReactComponent };